import * as React from "react";
import FormControl from "@mui/material/FormControl";
import {FormHelperText} from "@mui/material";
import {ReactNode, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {convertToTranslationKeys, ValidationError} from "../../../services/validator";
import {useTranslation} from "react-i18next";

export interface ISelectOption {
    label: string;
    value: any;
}

interface ISelectFieldProps {
    label: string;
    options: ISelectOption[] | any[];
    value: any;
    onChange(value: any): void;
    optionValueGetter?(option: any): any;
    optionLabelGetter?(option: any): string | ReactNode;
    optionDisabledGetter?(option: any): boolean;
    errors?: ValidationError[];
}

export const SelectField = ({label, options, value, onChange, optionValueGetter, optionLabelGetter, optionDisabledGetter = () => false, errors}: ISelectFieldProps) => {
    // const isSmallScreen = useMediaQuery(useTheme().breakpoints.down('xs'));
    const { t } = useTranslation();

    const [selected, setSelected] = useState<any>(value);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelected(event.target.value);
    };

    useEffect(() => {
        setSelected(value);
    }, [value]);

    useEffect(() => {
        onChange(selected);
    }, [selected]);

    // @todo the native select preselects the first item, if there is no EMPTY option, inject it at the top
    const SelectOption = MenuItem; // isSmallScreen ? 'option' : MenuItem;

    const _optionValueGetter = optionValueGetter || ((o: ISelectOption) => o.value);
    const _optionLabelGetter = optionLabelGetter || ((o: ISelectOption) => o.label);

    return (
        <FormControl fullWidth variant="outlined">
            <TextField
                select
                value={selected}
                onChange={handleChange}
                label={label}
                variant="outlined"
                error={!!errors && !!errors.length}
                slotProps={{
                    select: {
                        native: false,
                    },
                }}
            >
                {options.map((option, i) => (
                    <SelectOption key={i} value={_optionValueGetter(option)} disabled={optionDisabledGetter(option)}>
                        {_optionLabelGetter(option)}
                    </SelectOption>
                ))}
            </TextField>

            {!!errors && !!errors.length &&
                <FormHelperText error>
                    {convertToTranslationKeys(errors).map(e => t(e)).join(', ')}
                </FormHelperText>
            }
        </FormControl>
    );
}
